import { render, staticRenderFns } from "./RecommendedCourse.vue?vue&type=template&id=1338c0dc&scoped=true&"
import script from "./recommendedCourse.js?vue&type=script&lang=js&"
export * from "./recommendedCourse.js?vue&type=script&lang=js&"
import style0 from "./RecommendedCourse.vue?vue&type=style&index=0&id=1338c0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338c0dc",
  null
  
)

export default component.exports